export default "__VITE_ASSET__CM1EfZrV__"